import { Chip, GeneralManageVehiclesOutlineIcon, GeneralSunSunIcon } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';

import { RV_CAMPSITE_BUNDLES_LANDING_PAGE } from '@/constants/urls';
import { useRouter } from '@/hooks/useRouter';

import css from './Tabs.module.css';

export enum ETabsVariant {
  Rentals,
  Delivery,
  RvSite,
}

export enum ETabsColorVariant {
  White,
  Black,
}

interface ITabsProps {
  tabVariant: ETabsVariant;
  colorVariant?: ETabsColorVariant;
}

export const Tabs: React.FC<ITabsProps> = ({
  tabVariant,
  colorVariant = ETabsColorVariant.Black,
}) => {
  const intl = useIntl();
  const router = useRouter();

  const tabs = [
    {
      content: intl.formatMessage({ defaultMessage: 'RV Rentals', id: 'ctb+gI' }),
      vairant: ETabsVariant.Rentals,
      Icon: GeneralManageVehiclesOutlineIcon,
      url: '/',
    },
    // {
    //   content: intl.formatMessage({ defaultMessage: 'RV Delivery', id: 'esQwx2' }),
    //   vairant: ETabsVariant.Delivery,
    //   Icon: GeneralMapPinOutlineIcon,
    //   url: '/rv-delivery',
    // },
    {
      content: intl.formatMessage({ defaultMessage: 'Escapes', id: 'HIf3wo' }),
      vairant: ETabsVariant.RvSite,
      Icon: GeneralSunSunIcon,
      url: RV_CAMPSITE_BUNDLES_LANDING_PAGE,
    },
  ];

  const onTabClick = (url: string) => {
    router.push(url);
  };

  return (
    <div className="flex py-1 gap-1 md:gap-3">
      {tabs.map(({ content, url, vairant, Icon }, index) => {
        const isActive = vairant === tabVariant;
        return (
          <Chip
            key={index}
            content={content}
            onClick={() => onTabClick(url)}
            active={isActive}
            leftIcon={<Icon />}
            contentClassName={cn('[&>p]:text-[12px] md:[&>p]:text-base', css.tabContent, {
              '[&>p]:text-black [&>span]:text-black':
                colorVariant === ETabsColorVariant.White && !isActive,
              '[&>p]:text-white [&>span]:text-white':
                colorVariant === ETabsColorVariant.White && isActive,
            })}
            className={cn('!shadow-none', {
              'bg-[#EEECE3]': colorVariant === ETabsColorVariant.White,
            })}
            aria-label={intl.formatMessage(
              { defaultMessage: 'Navigate to {tabName}', id: 'w4XjBW' },
              { tabName: content },
            )}
          />
        );
      })}
    </div>
  );
};
